import { inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ResolveFn } from '@angular/router';
import {
  AuthSteps,
  customEnquiryOption,
  enquiryOptions,
  MapEnquiryOption,
  PROFILE_QUERY_PARAM_KEY,
} from '@lassi/webapp-shared';

// Return title and also update meta description
export const landingPageMetaResolver: ResolveFn<string> = () => {
  const meta = inject(Meta);

  meta.updateTag({
    name: 'description',
    content:
      'Find and update Victoria’s land and survey information, all in one place',
  });
  return 'LASSI - Land and Survey Spatial Information';
};

export const helpPageMetaResolver: ResolveFn<string> = () => {
  const meta = inject(Meta);

  meta.updateTag({
    name: 'description',
    content: 'Access a range of help and support resources for LASSI',
  });
  return 'Help using LASSI';
};

export const authPageMetaResolver: ResolveFn<string> = (route) => {
  const meta = inject(Meta);

  const authStep = route.queryParamMap.get('step') as AuthSteps | null;

  switch (authStep) {
    case AuthSteps.Signup:
    case AuthSteps.ConfirmSignup: {
      meta.updateTag({
        name: 'description',
        content: 'Enter your details to register for a LASSI account',
      });
      return 'Register for a LASSI account';
    }

    default: {
      meta.updateTag({
        name: 'description',
        content: 'Enter your details to login to your LASSI account',
      });
      return 'Login to your LASSI account';
    }
  }
};

export const enquiryTypeResolver: ResolveFn<string> = (route) => {
  const meta = inject(Meta);
  const currentEnquiry =
    route.data?.['enquiryOption']?.id ?? // landing enquiry page
    route.queryParamMap.get(PROFILE_QUERY_PARAM_KEY) ?? // landing enquiry page
    MapEnquiryOption.PropertyEnquiry; // fallback

  const option =
    [...enquiryOptions, customEnquiryOption].find(
      (option) => option.id === currentEnquiry,
    ) ?? enquiryOptions[0];

  meta.updateTag({
    name: 'description',
    content: option.description,
  });
  return option.htmlTitle ?? option.title;
};
